import { deleteRequest, get, patch, post } from "../utils/api";

export const virtualAdd = (data) => {
  return post("/items", data);
};

export const virtualGet = (data) => {
  return get(`/items`, data);
};

export const virtualItemStatusChange = ({ id, onSuccess, ...body }) => {
  return patch(`/items/${id}`, body);
};

export const virtualDelete = (data) => {
  return deleteRequest(`/items/${data.id}`);
};

export const virtualGetById = (data) => {
  return get(`/items/${data.id}`);
};

export const virtualUpdateItem = (data) => {
  const { id, ...rest } = data;
  return patch(`/items/${id}`, rest);
};

export const virtualLockerApi = {
  virtualAdd,
  virtualGet,
  virtualGetById,
  virtualUpdateItem,
  virtualItemStatusChange,
  virtualDelete,
  getItemNotes: (id) => get(`/items/${id}/notes?type=customer_decline`),
};
